import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { AdvancedRequestStatusReport } from './Pages'

export const AdvancedRequestStatusReportRoute = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={AdvancedRequestStatusReport} />
    </Fragment>
)